import { fromDatePickerFormat, toDatePickerFormat } from '../../../../../utils/dateHelpers';
import { updateProfileDataThunk } from '../../../../../store/workspace/thunks';
import { useDispatch, useSelector } from '../../../../../store/store';
import { errorMessages } from '../../../../../config/notification';
import RadioButton from '../../../../../components/RadioButton';
import DatePicker from '../../../../../components/DatePicker';
import TextArea from '../../../../../components/TextArea';
import Button from '../../../../../components/Button';
import Modal from '../../../../../components/Modal';
import Input from '../../../../../components/Input';
import styles from './style.module.scss';
import { v4 as uuid } from 'uuid';
import { useEffect, useState } from 'react';
import {
    setAddWorkExperienceModal,
    setSelectedWorkExperience,
    setWorkExperienceEditMode,
} from '../../../../../store/workspace/slice';
import {
    selectProfileData,
    selectUpdatingProfileData,
    selectSelectedWorkExperience,
    selectWorkExperienceEditMode,
} from '../../../../../store/workspace/selectors';

export default function AddWorkExperience() {
    const dispatch = useDispatch();
    const profile = useSelector(selectProfileData);
    const isLoading = useSelector(selectUpdatingProfileData);
    const selectedExperience = useSelector(selectSelectedWorkExperience);
    const editMode = useSelector(selectWorkExperienceEditMode);
    const [dateRangeError, setDateRangeError] = useState(false);
    const [jobTitle, setJobTitle] = useState(selectedExperience?.jobTitle || '');
    const [company, setCompany] = useState(selectedExperience?.company || '');
    const [location, setLocation] = useState(selectedExperience?.location || '');
    const [from, setFrom] = useState(selectedExperience?.from || '');
    const [to, setTo] = useState(selectedExperience?.to || '');
    const [roleDescription, setRoleDescription] = useState(selectedExperience?.roleDescription || '');
    const [currentlyworkHere, setCurrentlyworkHere] = useState(selectedExperience && !selectedExperience.to ? true : false);

    useEffect(() => {
        return () => {
            dispatch(setWorkExperienceEditMode(false));
            dispatch(setSelectedWorkExperience(null));
        }
    }, []);

    const submit = () => {
        if (!profile) return;
        const { kyc, matchedJobs, setting, ...rest } = profile;

        if (editMode) {
            const filteredList = profile.workExperience.filter(i => i.id !== selectedExperience?.id);

            const record = {
                from,
                company,
                jobTitle,
                location,
                roleDescription,
                id: selectedExperience?.id,
                to: currentlyworkHere ? '' : to,
            };

            dispatch(updateProfileDataThunk({
                ...rest,
                workExperience: [...filteredList, record]
            }));
        } else {
            const newRecord = {
                from,
                company,
                jobTitle,
                location,
                id: uuid(),
                roleDescription,
                to: currentlyworkHere ? '' : to,
            };

            dispatch(updateProfileDataThunk({
                ...rest,
                workExperience: [...profile.workExperience, newRecord]
            }));
        }
    };

    return (
        <Modal
            size='md'
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setAddWorkExperienceModal(false))}
            title={editMode ? 'Edit work experience' : 'Add work experience'}
        >
            <Input
                type='text'
                label='Job title'
                value={jobTitle}
                listIdKey='id'
                listTitleKey='title'
                onChange={setJobTitle}
            />
            <Input
                type='text'
                label='Company'
                value={company}
                onChange={setCompany}
            />
            <Input
                type='text'
                label='Location'
                value={location}
                onChange={setLocation}
            />
            <TextArea
                label='Role description'
                value={roleDescription}
                onChange={setRoleDescription}
            />
            <div className={styles.date}>
                <RadioButton
                    text="I currently work here"
                    checked={currentlyworkHere}
                    setChecked={(val: boolean) => setCurrentlyworkHere(val)}
                />
                <div className={styles.date_fromTo}>
                    <DatePicker
                        label='From'
                        placeholder='MM-DD-YYYY'
                        selectedDate={toDatePickerFormat(from)}
                        setSelectedDate={(val) => setFrom(fromDatePickerFormat(val))}
                        errorMessage={dateRangeError ? 'has-error' : ''}
                    />
                    {!currentlyworkHere && <DatePicker
                        label='To'
                        placeholder='MM-DD-YYYY'
                        selectedDate={toDatePickerFormat(to)}
                        setSelectedDate={(val) => setTo(fromDatePickerFormat(val))}
                        errorMessage={dateRangeError ? 'has-error' : ''}
                    />}
                </div>
                {dateRangeError && (<span className={styles.date_error}>{errorMessages.dateRange}</span>)}
            </div>
            <Button
                text='Save'
                type='Primary'
                onClick={submit}
                loading={isLoading}
                disabled={
                    !from ||
                    !company ||
                    !location ||
                    !jobTitle ||
                    !roleDescription ||
                    (!currentlyworkHere && !to)
                }
            />
        </Modal>
    )
}
